<!--小区管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="2"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="小区名称： ">
                  <el-input
                    placeholder="请输入机构名称..."
                    v-model="search.VILLAGE_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">商圈：</label>
                  <el-input
                    placeholder="请输入商圈..."
                    v-model="search.AREA_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">学校：</label>
                  <el-input
                    placeholder="请输入学校..."
                    v-model="search.SCHOOL_NAME"
                  ></el-input>

                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <el-button
                    type="warning"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="addHandler"
                  >
                    添加小区
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                @click="roleBgHandler(scope.row)"
                type="text"
                size="small"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
            </el-table-column>
          </template>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->

      <!-- 权限变更 开始 -->
      <el-dialog
        :title="czData.flag === 'ADD' ? '添加小区' : '修改小区'"
        :visible.sync="dialogVisible"
        width="86%"
      >
        <span>
          <div class="addClassModel">
            <div
              style="font-size: 17px;font-weight: 600;text-align: left;margin-bottom: 20px;"
            >
              基础设置
            </div>
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;"
                    >小区名称<span style="color:red">*</span>：</label
                  >
                  <el-input
                    v-model="czData.row.VILLAGE_NAME"
                    style="width:80%;"
                    placeholder="请输入小区名称..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;"
                    >地址<span style="color:red">*</span>：</label
                  >
                  <el-input
                    v-model="czData.row.VILLAGE_ADDRESS"
                    style="width:80%;"
                    placeholder="请输入地址..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;"
                    >均价<span style="color:red">*</span>：</label
                  >
                  <el-input
                    v-model="czData.row.AVERAGE_PRICE"
                    style="width:80%;"
                    placeholder="请输入均价..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">经度：</label>
                  <el-input
                    v-model="czData.row.POS_X"
                    style="width:80%;"
                    placeholder="请输入经度..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">纬度：</label>
                  <el-input
                    v-model="czData.row.POS_Y"
                    style="width:80%;"
                    placeholder="请输入纬度..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">楼栋总数：</label>
                  <el-input
                    v-model="czData.row.BUILDING_TOTAL"
                    style="width:80%;"
                    placeholder="请输入楼栋总数..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">房屋总户数：</label>
                  <el-input
                    v-model="czData.row.HOUSE_TOTAL"
                    style="width:80%;"
                    placeholder="请输入房屋总户数..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">车位总数：</label>
                  <el-input
                    v-model="czData.row.PARKING_TOTAL"
                    style="width:80%;"
                    placeholder="请输入车位总数..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">建筑年代：</label>
                  <el-input
                    v-model="czData.row.BUILT_YEAR"
                    style="width:80%;"
                    placeholder="请输入建筑年代..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">开发商：</label>
                  <el-input
                    v-model="czData.row.VILLAGE_DEVELOPER"
                    style="width:80%;"
                    placeholder="请输入开发商..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">物业公司：</label>
                  <el-input
                    v-model="czData.row.PROPERTY_COMPANY"
                    style="width:80%;"
                    placeholder="请输入物业公司..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">物业费：</label>
                  <el-input
                    v-model="czData.row.PROPERTY_PRICE"
                    style="width:80%;"
                    placeholder="请输入物业费..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">产权性质：</label>
                  <el-input
                    v-model="czData.row.PROPERTY_RIGHT"
                    style="width:80%;"
                    placeholder="请输入开发商..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">绿化率：</label>
                  <el-input
                    v-model="czData.row.GREEN_RATE"
                    style="width:80%;"
                    placeholder="请输入绿化率..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">容积率：</label>
                  <el-input
                    v-model="czData.row.PLOT_RATE"
                    style="width:80%;"
                    placeholder="请输入容积率..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">在售房源总数：</label>
                  <el-input
                    v-model="czData.row.SALE_HOUSE_NUM"
                    style="width:80%;"
                    placeholder="请输入在售房源总数..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">在租房源总数：</label>
                  <el-input
                    v-model="czData.row.RENT_HOUSE_NUM"
                    style="width:80%;"
                    placeholder="请输入在租房源总数..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;"> </el-col>
              </el-row>
            </div>

            <div
              style="font-size: 17px;font-weight: 600;text-align: left;margin-bottom: 20px;"
            >
              商圈设置
            </div>
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <el-autocomplete
                    v-model="czData.row.CITY_NAME"
                    placeholder="区域..."
                    clearable
                    @select="cityHandleSelect"
                    :fetch-suggestions="cityQuerySearchAsync"
                    style="width:390px"
                  >
                    <template slot="prepend">
                      区域：
                    </template>
                  </el-autocomplete>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <div>
                    <el-autocomplete
                      v-if="
                        czData.row.CITY_NAME !== undefined &&
                          czData.row.CITY_NAME.length > 0
                      "
                      v-model="czData.row.AREA_NAME"
                      placeholder="商圈..."
                      clearable
                      @select="areaHandleSelect"
                      :fetch-suggestions="areaQuerySearchAsync"
                      style="width:390px"
                    >
                      <template slot="prepend">
                        商圈：
                      </template>
                    </el-autocomplete>
                  </div>
                </el-col>
                <el-col :span="8" style="text-align: left;"> </el-col>
              </el-row>
            </div>

            <div
              style="font-size: 17px;font-weight: 600;text-align: left;margin-bottom: 20px;"
            >
              学校设置
            </div>
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label style="margin-left:6px;">小学：</label>
                  <el-select
                    v-model="smallSchoolSelectedIds"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请选择小学（可多选）..."
                    :remote-method="smallSchoolRemoteMethod"
                    :loading="smallSchoolLoading"
                    style="width:80%;"
                    @change="smallSchoolHandleChange"
                  >
                    <el-option
                      v-for="item in smallSchoolOptions"
                      :key="item.SCHOOL_ID"
                      :label="item.SCHOOL_NAME"
                      :value="item.SCHOOL_ID"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label style="margin-left:6px;">中学：</label>
                  <el-select
                    v-model="campusSchoolSelectedIds"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请选择中学（可多选）..."
                    :remote-method="campusSchoolRemoteMethod"
                    :loading="campusSchoolLoading"
                    style="width:80%;"
                    @change="campusSchoolHandleChange"
                  >
                    <el-option
                      v-for="item in campusSchoolOptions"
                      :key="item.SCHOOL_ID"
                      :label="item.SCHOOL_NAME"
                      :value="item.SCHOOL_ID"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label style="margin-left:6px;">小区介绍：</label>
                  <textarea
                    v-model="czData.row.VILLAGE_DESCRIBE"
                    style="width:80%;height:200px;"
                  ></textarea>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="addOrEditorOrDel">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 权限变更 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "PersonGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {},
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "ID",
          colText: "ID",
          colShow: false
        },
        {
          colName: "VILLAGE_NAME",
          colText: "小区名称",
          colShow: true
        },
        {
          colName: "AREA_ID",
          colText: "商圈ID",
          colShow: false
        },
        {
          colName: "AREA_NAME",
          colText: "商圈名称",
          colShow: true
        },
        {
          colName: "CITY_ID",
          colText: "城市ID",
          colShow: false
        },
        {
          colName: "CITY_NAME",
          colText: "城市名称",
          colShow: true
        },
        {
          colName: "VILLAGE_ADDRESS",
          colText: "地址",
          colShow: true
        },
        {
          colName: "AVERAGE_PRICE",
          colText: "均价",
          colShow: true
        },
        {
          colName: "POS_X",
          colText: "经度",
          colShow: true
        },
        {
          colName: "POS_Y",
          colText: "纬度",
          colShow: true
        },
        {
          colName: "CAMPUS_ID",
          colText: "小区编号",
          colShow: false
        },
        {
          colName: "BUILDING_TOTAL",
          colText: "楼栋总数",
          colShow: true
        },
        {
          colName: "HOUSE_TOTAL",
          colText: "房屋总户数",
          colShow: true
        },
        {
          colName: "PARKING_TOTAL",
          colText: "车位总数",
          colShow: true
        },
        {
          colName: "ADD_TIME",
          colText: "添加时间",
          colShow: true
        },
        {
          colName: "BUILT_YEAR",
          colText: "建筑年代",
          colShow: true
        },
        {
          colName: "VILLAGE_DEVELOPER",
          colText: "开发商",
          colShow: true
        },
        {
          colName: "PROPERTY_COMPANY",
          colText: "物业公司",
          colShow: true
        },
        {
          colName: "PROPERTY_PRICE",
          colText: "物业费",
          colShow: true
        },
        {
          colName: "VILLAGE_DESCRIBE",
          colText: "小区介绍",
          colShow: false
        },
        {
          colName: "ATTACH_ID",
          colText: "备注",
          colShow: false
        },
        {
          colName: "ADD_USER_ID",
          colText: "ADD_USER_ID",
          colShow: false
        },
        {
          colName: "SMALL_CAMPUS_ID",
          colText: "学校编号",
          colShow: false
        },
        {
          colName: "SCHOOL_NAME",
          colText: "小学名称",
          colShow: true
        },
        {
          colName: "CAMPUS_NAME",
          colText: "中学名称",
          colShow: true
        },
        {
          colName: "PROPERTY_RIGHT",
          colText: "产权性质",
          colShow: true
        },
        {
          colName: "GREEN_RATE",
          colText: "绿化率",
          colShow: true
        },
        {
          colName: "PLOT_RATE",
          colText: "容积率",
          colShow: true
        },
        {
          colName: "AGENT_USER_ID",
          colText: "维护人ID",
          colShow: true
        },
        {
          colName: "SALE_HOUSE_NUM",
          colText: "在售房源总数",
          colShow: true
        },
        {
          colName: "RENT_HOUSE_NUM",
          colText: "在租房源总数",
          colShow: true
        }
      ],
      tableData: [],
      czData: {
        row: {},
        flag: "ADD"
      },
      dialogVisible: false,
      // 学校选择相关
      smallSchoolSelectedIds: [], // 小学选中的ID数组
      campusSchoolSelectedIds: [], // 中学选中的ID数组
      smallSchoolOptions: [], // 小学选项列表
      campusSchoolOptions: [], // 中学选项列表
      smallSchoolLoading: false, // 小学加载状态
      campusSchoolLoading: false // 中学加载状态
    };
  },
  created() {
    this.op = "adminCommunityGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      //alert(JSON.stringify(this.pageSet));
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    roleBgHandler(row) {
      this.czData.row = JSON.parse(JSON.stringify(row));
      this.czData.flag = "UPT";
      // 处理小学学校ID回显
      this.smallSchoolSelectedIds = [];
      if (row.SMALL_CAMPUS_ID && row.SMALL_CAMPUS_ID.length > 0) {
        try {
          this.smallSchoolSelectedIds = row.SMALL_CAMPUS_ID.split(",").filter(
            id => id && id.trim()
          );
        } catch (e) {
          console.error("解析小学学校ID失败", e);
        }
      }
      // 处理中学学校ID回显
      this.campusSchoolSelectedIds = [];
      if (row.CAMPUS_ID && row.CAMPUS_ID.length > 0) {
        try {
          this.campusSchoolSelectedIds = row.CAMPUS_ID.split(",").filter(
            id => id && id.trim()
          );
        } catch (e) {
          console.error("解析中学学校ID失败", e);
        }
      }
      this.dialogVisible = true;
      // 对话框打开后，如果有区域ID，加载学校列表
      this.$nextTick(() => {
        if (this.czData.row.CITY_ID) {
          this.smallSchoolRemoteMethod("");
          this.campusSchoolRemoteMethod("");
          // 如果有已选中的学校，加载其详细信息用于显示
          if (
            this.smallSchoolSelectedIds.length > 0 ||
            this.campusSchoolSelectedIds.length > 0
          ) {
            this.loadSelectedSchools();
          }
        }
      });
    },
    addHandler() {
      this.czData.flag = "ADD";
      this.czData.row = {};
      this.smallSchoolSelectedIds = [];
      this.campusSchoolSelectedIds = [];
      this.smallSchoolOptions = [];
      this.campusSchoolOptions = [];
      this.dialogVisible = true;
    },
    /**分页方法 结束 */
    addOrEditorOrDel() {
      if (!this.czData.row.VILLAGE_NAME) {
        alert("请输入必输项");
        return;
      }
      if (!confirm("是否提交？")) {
        return;
      }
      var busData = {
        row: this.czData.row,
        flag: this.czData.flag
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "addOrEditorOrDel" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.mainLoad();
          this.dialogVisible = false;
          return;
        }
      });
    },
    //公共方法
    createStateFilter(queryString) {
      return state => {
        return state.value.indexOf(queryString) > -1;
      };
    },
    /**选择区域 开始 */
    cityQuerySearchAsync(queryString, cb) {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "getCity" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPostNoLoading().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        var restaurants = data.content;
        var results = queryString
          ? restaurants.filter(this.createStateFilter(queryString))
          : restaurants;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 100);
      });
    },

    /**选择区域 结束 */
    /**选择商圈 开始 */
    areaQuerySearchAsync(queryString, cb) {
      var busData = {
        CITY_ID: this.czData.row.CITY_ID
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "getArea" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPostNoLoading().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        var restaurants = data.content;
        var results = queryString
          ? restaurants.filter(this.createStateFilter(queryString))
          : restaurants;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 100);
      });
    },

    areaHandleSelect(item) {
      this.czData.row.AREA_ID = item.AREA_ID;
      this.czData.row.AREA_NAME = item.AREA_NAME;
    },
    /**选择商圈 结束 */

    /**选择学校 开始 */
    // 加载已选中的学校信息
    loadSelectedSchools() {
      if (!this.czData.row.CITY_ID) return;

      // 加载小学
      if (this.smallSchoolSelectedIds.length > 0) {
        this.loadSchoolOptions(this.smallSchoolSelectedIds, "small");
      }
      // 加载中学
      if (this.campusSchoolSelectedIds.length > 0) {
        this.loadSchoolOptions(this.campusSchoolSelectedIds, "campus");
      }
    },

    // 加载学校选项（用于回显已选中的学校）
    loadSchoolOptions(ids, type) {
      if (!ids || ids.length === 0 || !this.czData.row.CITY_ID) return;

      var busData = {
        CITY_ID: this.czData.row.CITY_ID,
        SCHOOL_NAME: "" // 不按名称过滤，获取所有
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "getSchool"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPostNoLoading().then(data => {
        if (data.isSuccess && data.content) {
          const allSchools = data.content;
          // 将已选中的学校添加到选项列表中
          const selectedSchools = allSchools.filter(school =>
            ids.includes(String(school.SCHOOL_ID))
          );
          if (type === "small") {
            // 合并已选中的学校和当前选项列表，去重
            const existingIds = this.smallSchoolOptions.map(s =>
              String(s.SCHOOL_ID)
            );
            selectedSchools.forEach(school => {
              if (!existingIds.includes(String(school.SCHOOL_ID))) {
                this.smallSchoolOptions.push(school);
              }
            });
          } else if (type === "campus") {
            // 合并已选中的学校和当前选项列表，去重
            const existingIds = this.campusSchoolOptions.map(s =>
              String(s.SCHOOL_ID)
            );
            selectedSchools.forEach(school => {
              if (!existingIds.includes(String(school.SCHOOL_ID))) {
                this.campusSchoolOptions.push(school);
              }
            });
          }
        }
      });
    },

    // 小学远程搜索方法
    smallSchoolRemoteMethod(query) {
      if (!this.czData.row.CITY_ID) {
        this.smallSchoolOptions = [];
        return;
      }

      if (query !== "") {
        this.smallSchoolLoading = true;
        var busData = {
          CITY_ID: this.czData.row.CITY_ID,
          SCHOOL_NAME: query
        };
        var paramData = {
          headerData: {
            op: this.op,
            methodName: "getSchool"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost
          .sendPostNoLoading()
          .then(data => {
            this.smallSchoolLoading = false;
            if (data.isSuccess) {
              this.smallSchoolOptions = data.content || [];
            } else {
              this.smallSchoolOptions = [];
              alert(data.msg);
            }
          })
          .catch(() => {
            this.smallSchoolLoading = false;
            this.smallSchoolOptions = [];
          });
      } else {
        // 输入为空时，加载默认50条
        this.smallSchoolLoading = true;
        var busData = {
          CITY_ID: this.czData.row.CITY_ID,
          SCHOOL_NAME: ""
        };
        var paramData = {
          headerData: {
            op: this.op,
            methodName: "getSchool"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost
          .sendPostNoLoading()
          .then(data => {
            this.smallSchoolLoading = false;
            if (data.isSuccess) {
              this.smallSchoolOptions = data.content || [];
            } else {
              this.smallSchoolOptions = [];
            }
          })
          .catch(() => {
            this.smallSchoolLoading = false;
            this.smallSchoolOptions = [];
          });
      }
    },

    // 中学远程搜索方法
    campusSchoolRemoteMethod(query) {
      if (!this.czData.row.CITY_ID) {
        this.campusSchoolOptions = [];
        return;
      }

      if (query !== "") {
        this.campusSchoolLoading = true;
        var busData = {
          CITY_ID: this.czData.row.CITY_ID,
          SCHOOL_NAME: query
        };
        var paramData = {
          headerData: {
            op: this.op,
            methodName: "getSchool"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost
          .sendPostNoLoading()
          .then(data => {
            this.campusSchoolLoading = false;
            if (data.isSuccess) {
              this.campusSchoolOptions = data.content || [];
            } else {
              this.campusSchoolOptions = [];
              alert(data.msg);
            }
          })
          .catch(() => {
            this.campusSchoolLoading = false;
            this.campusSchoolOptions = [];
          });
      } else {
        // 输入为空时，加载默认50条
        this.campusSchoolLoading = true;
        var busData = {
          CITY_ID: this.czData.row.CITY_ID,
          SCHOOL_NAME: ""
        };
        var paramData = {
          headerData: {
            op: this.op,
            methodName: "getSchool"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost
          .sendPostNoLoading()
          .then(data => {
            this.campusSchoolLoading = false;
            if (data.isSuccess) {
              this.campusSchoolOptions = data.content || [];
            } else {
              this.campusSchoolOptions = [];
            }
          })
          .catch(() => {
            this.campusSchoolLoading = false;
            this.campusSchoolOptions = [];
          });
      }
    },

    // 小学选择变化处理
    smallSchoolHandleChange(value) {
      // 将选中的ID数组转为逗号分隔的字符串
      if (value && value.length > 0) {
        this.czData.row.SMALL_CAMPUS_ID = value.join(",");
      } else {
        this.czData.row.SMALL_CAMPUS_ID = "";
      }
    },

    // 中学选择变化处理
    campusSchoolHandleChange(value) {
      // 将选中的ID数组转为逗号分隔的字符串
      if (value && value.length > 0) {
        this.czData.row.CAMPUS_ID = value.join(",");
      } else {
        this.czData.row.CAMPUS_ID = "";
      }
    },

    // 区域选择后，自动加载学校列表
    cityHandleSelect(item) {
      this.czData.row.CITY_ID = item.CITY_ID;
      this.czData.row.CTIY_NAME = item.CTIY_NAME;
      // 区域选择后，加载默认的学校列表
      if (this.dialogVisible) {
        this.smallSchoolRemoteMethod("");
        this.campusSchoolRemoteMethod("");
      }
    }
    /**选择学校 结束 */
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/communityGlIndex/CommunityGlIndex.vue